<template>
  <ChatRoom
    :title="$t('details')"
    v-model="showChatRoom"
    enableFileUpload
    createConnection
    v-bind="chatRoomBind"
    noLastRead
  >
    <template v-slot:issue>
      <v-card hover raised>
        <v-card-text>
          <v-layout>
            <v-flex>
              <strong>{{ $t('trackings') }}:</strong>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4 v-for="tracking in item.trackings" :key="tracking">
              <span class="non-uploaded-tracking">{{ tracking }}</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <FsFileChip 
              v-for="(file, index) in item.uploadedFiles"
              :file="file"
              :key="'file' + index"
              width="100%"
              aspect-ratio="1.7"
              class="ma-2"
            />
          </v-layout>
        </v-card-text>
      </v-card>   
    </template>
  </ChatRoom>
</template>

<script>
import ChatRoom from './ChatRoom'
import FsFileChip from './FsFileChip'

export default {
  name: 'UnScannedDetailPopup',
  components: {
    ChatRoom,
    FsFileChip
  },
  computed: {
    showChatRoom: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    chatRoomBind () {
      const warehousesKey = this.$store.getters.activeWarehouse
      const { _key, comments = [] } = this.item
      return {
        docPath: ['warehouses', warehousesKey, 'unScannedTrackings', _key],
        comments
      }
    }
  },
  props: {
    value: Boolean,
    item: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UnScannedDetailPopup.vue